import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SimilarProductsFilterState {
  sellerId: string | null;
  categoryFilter: {
    category?: string | null;
    searchString?: string | null;
    parentCategoryNameList?: string | [] | null;
    parentCategoryIdList?: number | [] | null;
    author?: string | null;
    page?: number;
  };
}
interface SimilarProductsState {
  isLoading: boolean;
  filter: SimilarProductsFilterState;
  similarProducts: any[];
  error: string | null;
  selectedProductId: string | null;
}
const initialState: SimilarProductsState = {
  selectedProductId: null,
  isLoading: false,
  filter: {
    sellerId: null,
    categoryFilter: {
      searchString: null,
      parentCategoryIdList: null,
      author: null,
      parentCategoryNameList: null,
      category: null,
      page: 1,
    },
  },
  similarProducts: [],
  error: null,
};
const similarProductsSlice = createSlice({
  name: "similarProducts",
  initialState,
  reducers: {
    getSimilarProductsStart: (
      state,
      action: PayloadAction<{
        similarProductsFor: string | null;
        filter: SimilarProductsFilterState;
      }>
    ) => {
      state.isLoading = true;
      state.error = null;
      state.filter = action.payload.filter;
      state.filter.sellerId = action.payload.filter.sellerId || null;
      state.selectedProductId = action.payload.similarProductsFor;
    },
    getSimilarProductsSuccess: (state, action: PayloadAction<any[]>) => {
      state.isLoading = false;
      state.similarProducts = action.payload;
      state.error = null;
    },
    getSimilarProductsFailure: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getSimilarProductsStart,
  getSimilarProductsSuccess,
  getSimilarProductsFailure,
} = similarProductsSlice.actions;

export default similarProductsSlice.reducer;
